import styled from "styled-components";

export const CustomStyles = {
  content: {
    width: "40%",
    height: "80%",
    margin: "auto",
    background: "var(--black-200) ",
    borderRadius: "5px",
    border: "none",
  },
  overlay: {
    backgroundColor: "rgba(25, 25, 25, 0.75)",
  },
};

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Header = styled.div`
  width: 100%;
  padding-top: 1.1rem;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.5rem;
    padding-bottom: 1.25rem;
    width: 100%;
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);

    img {
      cursor: pointer;
    }
  }
`;

export const DataContainer = styled.div`
  margin-bottom: 35px;
  margin-top: 35px;
`;

export const Content = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1.25rem;
  padding-left: 1.3rem;

  &:last-of-type {
    span:last-of-type {
      grid-column: span 2;
    }
  }

  span > label {
    margin-bottom: 0.25rem;
    color: var(--white);
    font-weight: 500;
    font-size: 1.0275rem;
  }

  p {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: var(--grey-100);
  }
`;
